/** Reading queue states on each text node. */
export const READING = {
  INBOX: "inbox",
  LATER: "later",
  REVIEW: "review",
  ARCHIVED: "archived",
  TRASH: "trash",
};

/** Days until next review (spaced repetition lite). */
export const REVIEW_INTERVALS_DAYS = [1, 3, 7, 14, 30];

export function nextReviewAt(reviewCount = 0) {
  const idx = Math.min(Math.max(0, reviewCount), REVIEW_INTERVALS_DAYS.length - 1);
  const days = REVIEW_INTERVALS_DAYS[idx];
  return Date.now() + days * 24 * 60 * 60 * 1000;
}

export function readingTabFor(text = {}) {
  const state = text.readingState || READING.INBOX;
  if (state === READING.TRASH) return "trash";
  if (state === READING.ARCHIVED) return "archived";
  if (state === READING.LATER) return "later";
  if (state === READING.REVIEW) return "review";
  if (text.reviewAt && text.reviewAt <= Date.now()) return "review";
  if (!text.isRead) return "unread";
  return "read";
}

export function isQueueVisible(text = {}) {
  const tab = readingTabFor(text);
  return tab === "unread" || tab === "later" || tab === "review";
}

export const READING_ACTIONS = [
  { id: "later", label: "Después", emoji: "⏳" },
  { id: "read", label: "Leído", emoji: "✓" },
  { id: "review", label: "Repasar", emoji: "↻" },
  { id: "archive", label: "Archivo", emoji: "📦" },
  { id: "trash", label: "Papelera", emoji: "🗑" },
];
